module.exports = __webpack_public_path__ + "img/offsetTradingIcon_active.e670dcfd.svg";